/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import FetchCitiesQuery from '../graphql/queries/FetchCitiesQuery.js';

const useFetchCitiesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(FetchCitiesQuery, args);

  return {
    error,
    loading,
    refetch,
    fetchCities: R.omit(['__typename'], data?.fetchCities_souscription_informations || {})
  };
};

export default useFetchCitiesQuery;
